import { render, staticRenderFns } from "./step_1_modified.vue?vue&type=template&id=2bb0919a&scoped=true"
import script from "./step_1_modified.vue?vue&type=script&lang=js"
export * from "./step_1_modified.vue?vue&type=script&lang=js"
import style0 from "./step_1_modified.vue?vue&type=style&index=0&id=2bb0919a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb0919a",
  null
  
)

export default component.exports